"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserContext = exports.JoinType = exports.HumanReadableHelpReason = exports.HumanReadableFeedbackReason = exports.HelpReason = exports.FeedbackReason = exports.InviteModalVersion = exports.SignInMethods = exports.DeskClaimSource = exports.EventSource = exports.MAP_CATEGORY_ENTERED_PROPERTY = exports.AmplitudeGroupIdentifyOperations = exports.AmplitudeIdentifyOperations = exports.MetricsGroupProperties = exports.MetricsGroupTypes = exports.MetricsUserProperties = exports.MetricsEventCategory = exports.MetricsEventName = void 0;
var MetricsEventName;
(function (MetricsEventName) {
    MetricsEventName["VISIT_PASSWORD_PAGE"] = "Visit Password-Protected Page";
    MetricsEventName["VISIT_AVATAR_CUSTOMIZATION_PAGE"] = "Visit Avatar Customization Page";
    MetricsEventName["VISIT_AV_SETUP_PAGE"] = "Visit \"Allow Camera & Microphone\" Page";
    MetricsEventName["CHANGE_APPEARANCE"] = "Change Appearance";
    MetricsEventName["COMPLETE_TUTORIAL"] = "Complete Tutorial";
    MetricsEventName["ENTER_SPACE"] = "Enter Space";
    MetricsEventName["STAY_IN_SPACE"] = "Stay in Space";
    MetricsEventName["ACTIVE_IN_SPACE"] = "Active in Space";
    MetricsEventName["SEND_FIRST_CHAT"] = "Send First Chat";
    MetricsEventName["SEND_FIRST_CHAT_TODAY"] = "Send First Chat Today";
    MetricsEventName["MOVE_FIRST_TIME"] = "Move in Space for First Time";
    MetricsEventName["REMOTE_WORK_CHANGE_MAP"] = "Change Map";
    MetricsEventName["PRESS_Z_TO_DANCE"] = "Press Z to Dance";
    MetricsEventName["REQUEST_TO_LEAD"] = "Request to Lead";
    MetricsEventName["ACCEPT_REQUEST_TO_LEAD"] = "Accept Request to Lead";
    MetricsEventName["LOCATE"] = "Locate";
    MetricsEventName["FOLLOW"] = "Follow";
    MetricsEventName["CLICK_SCREENSHARE"] = "Click Screenshare";
    MetricsEventName["CLICK_GRAPES_MENU"] = "Click Grapes Menu";
    MetricsEventName["SET_EMOTE"] = "Set Emote";
    MetricsEventName["RAISE_HAND"] = "Raise Hand";
    MetricsEventName["RING_USER"] = "Ring User";
    MetricsEventName["START_COMMUNITY_REACTION"] = "Start Community Reaction";
    MetricsEventName["CLICK_JOIN_SLACK_COMMUNITY"] = "Click Join Slack Community";
    MetricsEventName["SET_FULLSCREEN_PLAYER"] = "Set fullscreen player";
    MetricsEventName["REQUEST_PERMISSIONS"] = "Request Permissions";
    MetricsEventName["WALK_TO_PRIVATE_AREA"] = "Walk to private area";
    MetricsEventName["PIN_USER"] = "Pin user";
    MetricsEventName["WALK_TO_DESK"] = "Walk to desk";
    MetricsEventName["TOGGLE_SELF_VIEW"] = "Toggle self view";
    MetricsEventName["AV_ISSUE"] = "Experience Audio/Video Issue";
    MetricsEventName["AV_STUCK_CONNECTING"] = "Stuck connecting";
    MetricsEventName["AV_METRICS"] = "AV Metrics";
    MetricsEventName["VIDEO_MODE_TOGGLE"] = "Video Mode Toggle";
    MetricsEventName["VIDEO_RESIZE_BUTTON"] = "Video Resize Button";
    MetricsEventName["VIDEO_MODE_SELECT"] = "Video Mode Select";
    MetricsEventName["TIME_IN_GRID_VIEW"] = "Time In Grid View";
    MetricsEventName["TIME_IN_FULLSCREEN_VIEW"] = "Time In Fullscreen View";
    MetricsEventName["TIME_IN_MAP_VIEW_AND_CONNECTED"] = "Time In Map View And Connected";
    MetricsEventName["TIME_IN_VIDEO_VIEW"] = "Time In Video View";
    MetricsEventName["USE_SCREENSHARE_CURSOR"] = "Use Screenshare Cursor";
    MetricsEventName["USE_LIVE_CURSOR"] = "Use Live Cursor";
    MetricsEventName["USE_LIVE_CURSOR_CLICK"] = "Use Live Cursor Click";
    MetricsEventName["SCREENSHARE_ZOOM_RESET_BUTTON"] = "Screenshare Zoom Reset Button";
    MetricsEventName["SCREENSHARE_ZOOM_IN_BUTTON"] = "Screenshare Zoom In Button";
    MetricsEventName["SCREENSHARE_ZOOM_OUT_BUTTON"] = "Screenshare Zoom Out Button";
    MetricsEventName["SCREENSHARE_ZOOM_SLIDER"] = "Screenshare Zoom Set With Slider";
    MetricsEventName["SCREENSHARE_ZOOM_PAN"] = "Screenshare Zoom Pan";
    MetricsEventName["SCREENSHARE_ZOOM_PINCH"] = "Screenshare Zoom Pinch";
    MetricsEventName["SCREENSHARE_ZOOM_WHEEL_PAN"] = "Screenshare Zoom Wheel Pan";
    MetricsEventName["MUTE_PLAYER_FOR_EVERYONE"] = "Mute Player for Everyone";
    MetricsEventName["CONFIRM_MUTE_PLAYER_CLICKED"] = "Confirm Mute Player Clicked";
    MetricsEventName["TOGGLE_SELF_AUDIO"] = "Toggle Self Audio";
    MetricsEventName["TOGGLE_SELF_VIDEO"] = "Toggle Self Video";
    MetricsEventName["SET_PLAYER_LOCAL_VOLUME"] = "Set Player Local Volume";
    MetricsEventName["TOGGLE_ANNOTATION_SESSION"] = "Toggle Annotation Session";
    MetricsEventName["WINDOW_RESIZED"] = "Window Resized";
    MetricsEventName["SCREENSHARE_ANNOTATION_REQUESTED"] = "Screenshare Annotation Requested";
    MetricsEventName["SCREENSHARE_ANNOTATION_CLICKED_FROM_MINI_MODE_NAV"] = "Annotation Button Clicked From Mini Mode Nav";
    MetricsEventName["VIDEO_CLIENT"] = "Video Client";
    MetricsEventName["COPY_INVITE_LINK"] = "Copy Invite Link";
    MetricsEventName["OPEN_INVITE_MODAL"] = "Open Invite Modal";
    MetricsEventName["SHOW_INVITE_MODAL_WHEN_ALONE"] = "Show Invite Modal When Alone in Space";
    MetricsEventName["SENT_INVITE_EMAIL"] = "Sent Invite Email";
    MetricsEventName["CLOSE_INVITE_MODAL"] = "Close Invite Modal";
    MetricsEventName["VISIT_INVITE_LINK_INITIAL"] = "Visit Invite Link Initial";
    MetricsEventName["VISIT_INVITE_LINK_SIGNED_OUT"] = "Visit Invite Link Signed Out";
    MetricsEventName["VISIT_INVITE_LINK_WRONG_ACCOUNT"] = "Visit Invite Link Wrong Account";
    MetricsEventName["JOIN_VIA_INVITE_LINK"] = "Join Via Invite Link";
    MetricsEventName["ACCEPT_INVITE_LINK"] = "Accept Invite Link";
    MetricsEventName["CONNECTION_START"] = "Start a Connection";
    MetricsEventName["CONNECTION_END"] = "End a Connection";
    MetricsEventName["CONNECTION_START_AREA"] = "Start a Connection in an Area";
    MetricsEventName["CONNECTION_END_AREA"] = "End a Connection in an Area";
    MetricsEventName["CONNECTION_START_AMBIENT"] = "Start an ambient connection";
    MetricsEventName["CONNECTION_END_AMBIENT"] = "End an ambient connection";
    MetricsEventName["CONNECTION_PING"] = "Connection Ping";
    MetricsEventName["AREA_CONNECTION_PING"] = "Area Connection Ping";
    MetricsEventName["AMBIENT_CONNECTION_PING"] = "Ambient Connection Ping";
    MetricsEventName["HAVE_SHORT_CONVO_VIDEO_REQ"] = "Have Short Conversation Video Required";
    MetricsEventName["HAVE_SHORT_CONVO_NO_VIDEO_REQ"] = "Have Short Conversation No Video Req";
    MetricsEventName["FIRST_SPACE_FIRST_CONVERSATION"] = "User's first conversation in first owned space";
    MetricsEventName["ENTER_NOOK"] = "Enter Nook";
    MetricsEventName["EXIT_NOOK"] = "Exit Nook";
    MetricsEventName["HAVE_CONVO_END_CALL_MODAL"] = "Have Conversation (End Call Modal)";
    MetricsEventName["END_CALL_FEEDBACK"] = "End Call Feedback";
    MetricsEventName["PERFORMANCE_FEEDBACK"] = "Performance Feedback";
    MetricsEventName["RATING_OPPORTUNITY"] = "Rating Opportunity";
    MetricsEventName["DENY_RATING_OPPORTUNITY"] = "Deny Rating Opportunity";
    MetricsEventName["HAD_RATING_BLOCKED"] = "Had Rating Blocked";
    MetricsEventName["PERFORMANCE_SURVEY_RESPONSE"] = "Performance Survey Response";
    MetricsEventName["SHOW_PERFORMANCE_SURVEY_PROMPT"] = "Show Performance Survey Prompt";
    MetricsEventName["ACCEPT_PERFORMANCE_SURVEY_PROMPT"] = "Accept Performance Survey Prompt";
    MetricsEventName["DENY_PERFORMANCE_SURVEY_PROMPT"] = "Deny Performance Survey Prompt";
    MetricsEventName["PERFORMANCE_SURVEY_CLOSE_REQUEST"] = "Performance Survey Close Request";
    MetricsEventName["PERFORMANCE_SURVEY_CLOSE_CANCEL"] = "Performance Survey Close Cancel";
    MetricsEventName["BLOCK_USER"] = "Block User";
    MetricsEventName["UNBLOCK_USER"] = "Unblock User";
    MetricsEventName["BAN_USER"] = "Ban User from Space";
    MetricsEventName["KICK_USER"] = "Kick User from Space";
    MetricsEventName["REPORT_USER"] = "Report User";
    MetricsEventName["SPOTLIGHT_USER"] = "Spotlight User";
    MetricsEventName["INTERACT_WITH_OBJECT"] = "Interact with Object";
    MetricsEventName["OPEN_CUSTOMIZE_TAB"] = "Open Customize Tab";
    MetricsEventName["ENTER_MAPMAKER"] = "Enter MapMaker";
    MetricsEventName["NEW_MAPMAKER_ROOM"] = "New MapMaker Room";
    MetricsEventName["SET_MAP_BACKGROUND"] = "Set Map Background";
    MetricsEventName["OPEN_WALLS_AND_FLOORS_TOOL"] = "Open Walls and Floors Tool";
    MetricsEventName["SAVE_MAP"] = "Save Map";
    MetricsEventName["RENAME_NOOK"] = "Rename Nook";
    MetricsEventName["ATTEMPT_EMAIL_SEND"] = "Attempt to Send Email";
    MetricsEventName["EMAIL_SENT"] = "Sent Email";
    MetricsEventName["SIGN_IN_ERROR"] = "Sign In Error";
    MetricsEventName["GOOGLE_LOGIN"] = "Attempt to Sign In with Google";
    MetricsEventName["SIGN_IN"] = "Sign In";
    MetricsEventName["SIGN_IN_PAGE_VIEWED"] = "Sign In Page Viewed";
    MetricsEventName["SIGN_OUT"] = "Sign Out";
    MetricsEventName["PERF_HIGH_FRAME_DROP_PERIOD"] = "[Perf] High Frame Drop Period";
    MetricsEventName["CPU"] = "[Perf] User CPU";
    MetricsEventName["PERF_METRICS_BATCH"] = "Perf Metrics Batch";
    MetricsEventName["PERF_METRICS_BATCH_ANOMALY"] = "Perf Metrics Batch (Anomaly)";
    MetricsEventName["REFRESH_DETECTED"] = "Refresh Detected";
    MetricsEventName["PERF_LONG_ANIMATION_FRAME"] = "[Perf] Long Animation Frame";
    MetricsEventName["PERF_5S_LONG_TASK"] = "[Perf] 5s+ Long Task";
    MetricsEventName["PERF_10S_LONG_TASK_SEQ_IN_5M"] = "[Perf] 10s Long Task Seq in 5m";
    MetricsEventName["PERF_20S_LONG_TASK_SEQ_IN_5M"] = "[Perf] 20s Long Task Seq in 5m";
    MetricsEventName["PERF_10S_LONG_TASK_SEQ_IN_2M"] = "[Perf] 10s Long Task Seq in 2m";
    MetricsEventName["CONTEXT_LOSS"] = "Context Loss";
    MetricsEventName["PERF_30S_FIRST_ATLAS"] = "[Perf] 30s+ First Atlas v2";
    MetricsEventName["FATAL_ERROR"] = "Fatal Error";
    MetricsEventName["CREATE_SPACE"] = "Create Space";
    MetricsEventName["UPGRADE_SPACE"] = "Upgrade Space";
    MetricsEventName["UPGRADE_SPACE_ATTEMPTED"] = "Upgrade Space Attempted";
    MetricsEventName["DOWNLOAD_DESKTOP_APP"] = "Download Desktop App";
    MetricsEventName["VISIT_USER_HOME_PAGE"] = "Visit User Home Page";
    MetricsEventName["START_WHISPER"] = "Start Whisper";
    MetricsEventName["END_WHISPER"] = "End Whisper";
    MetricsEventName["PLACE_OBJECT"] = "Place Object in Space";
    MetricsEventName["DELETE_OBJECT"] = "Delete Object in Space";
    MetricsEventName["CLICK_BANNER_SIGN_IN"] = "Click Banner to Sign In";
    MetricsEventName["COMPLETED_TUTORIAL_TASK"] = "Completed Tutorial Task";
    MetricsEventName["STARTED_OFFICE_DEMO"] = "Started Office Demo";
    MetricsEventName["VISIT_CREATE_NEW_SPACE_PAGE"] = "Visit Create New Space Page";
    MetricsEventName["CLICK_TRY_OUT_LIVE_WALKTHROUGH"] = "Click Try Out Live Walkthrough";
    MetricsEventName["SHOW_NEW_TAB_OPENED_MODAL"] = "Show New Tab Opened Modal";
    MetricsEventName["SHOW_NEW_TAB_OPENED_MODAL_FROM_MINIMODE"] = "Show New Tab Opened Modal From MiniMode";
    MetricsEventName["SHOOT_CONFETTI"] = "Shoot confetti";
    MetricsEventName["RW_PREPOPULATED_OFFICE_NAME"] = "RW Prepopulated Office Name";
    MetricsEventName["RW_START_MEETING"] = "RW Start Meeting";
    MetricsEventName["RW_LEAVE_SPACE_FROM_MEETING"] = "RW Leave Space From Meeting";
    MetricsEventName["RESERVATIONS_CANCEL_RESERVATION"] = "Reservations: Cancel Reservation";
    MetricsEventName["DESKTOP_START_SCREENSHARE"] = "Desktop Start Screenshare";
    MetricsEventName["SPACE_ACCESS_RESTRICTION_EDITED"] = "Space Access Restriction Edited";
    MetricsEventName["APPROVE_SHARE_PLAYER_ID"] = "approve getPublicId";
    MetricsEventName["CLICKACTION_MOVE"] = "Click to Move";
    MetricsEventName["CLICKACTION_FOLLOW"] = "Click to Follow";
    MetricsEventName["CLICKACTION_SENDCHAT"] = "Click to Send Chat";
    MetricsEventName["CLICKACTION_STARTBUBBLE"] = "Click to Start Bubble";
    MetricsEventName["CLICKACTION_ADDOBJECT"] = "Click to Add Object";
    MetricsEventName["CLICKACTION_REMOVEOBJECT"] = "Click to Remove Object";
    MetricsEventName["CALENDAR_CONNECT_GCAL"] = "Connect GCal";
    MetricsEventName["CALENDAR_DISCONNECT_GCAL"] = "Disconnect GCal";
    MetricsEventName["CALENDAR_CONNECT_OUTLOOK"] = "Connect Outlook";
    MetricsEventName["CALENDAR_DISCONNECT_OUTLOOK"] = "Disconnect Outlook";
    MetricsEventName["CALENDAR_CLICK_CONNECT_GOOGLE"] = "Click connect google calendar";
    MetricsEventName["CALENDAR_CLICK_CONNECT_OUTLOOK"] = "Click connect outlook";
    MetricsEventName["CALENDAR_CREATE_NEW_EVENT"] = "Create New Event";
    MetricsEventName["CALENDAR_EVENT_OPEN_IN_GCAL"] = "Open Location in Google Calendar";
    MetricsEventName["CALENDAR_EVENT_CREATE_OUTLOOK_EVENT"] = "Create Outlook Event";
    MetricsEventName["CALENDAR_EVENT_COPY_LINK"] = "Copy Location Link";
    MetricsEventName["CALENDAR_OPEN_LEFTBAR_TAB"] = "Open Leftbar Calendar Tab";
    MetricsEventName["CALENDAR_USE_LOCATE"] = "Use Calendar Locate Feature";
    MetricsEventName["CALENDAR_USE_TELEPORT"] = "Use Calendar Teleport Feature";
    MetricsEventName["CALENDAR_NUM_DISPLAYED_CALS"] = "Number of Displayed Calendars";
    MetricsEventName["CALENDAR_UPDATE_SPACE_WIDE"] = "Update Space-wide Calendar Link";
    MetricsEventName["CALENDAR_CREATE_LOCATION"] = "Open Create Location Modal";
    MetricsEventName["CALENDAR_OPEN_MAPMAKER"] = "Open Mapmaker From Create Location Modal";
    MetricsEventName["CALENDAR_CREATE_SPAWN_TILE_ID"] = "Create Spawn Tile with ID";
    MetricsEventName["CALENDAR_REFRESH"] = "Refresh Calendar Events";
    MetricsEventName["GAME_CLIENT_STATS"] = "Game Client Stats";
    MetricsEventName["GAME_CLIENT_LATENCY"] = "Game Client Latency";
    MetricsEventName["GAME_CLIENT_RECONNECT"] = "Game Client Reconnect";
    MetricsEventName["GAME_CLIENT_FIRST_MAP_DATA"] = "Game Client First Map Data";
    MetricsEventName["SHOW_ENABLE_AREAS_MODAL"] = "Show Enable Areas Modal";
    MetricsEventName["ENABLE_AREA"] = "Enable Area";
    MetricsEventName["OPEN_SPECIFIC_AREA_MODAL"] = "Open Specific Area Modal";
    MetricsEventName["ENABLE_AREA_FROM_SPECIFIC_AREA_MODAL"] = "Enable Area From Specific Area Modal";
    MetricsEventName["COPY_INVITE_FROM_SPECIFIC_AREA_MODAL"] = "Copy Invite From Specific Area Modal";
    MetricsEventName["OPEN_SCHEDULE_EXPERIENCE_MODAL"] = "Open Schedule Experience Modal";
    MetricsEventName["COPY_INVITE_FROM_SCHEDULE_EXPERIENCE_MODAL"] = "Copy Invite From Schedule Experience Modal";
    MetricsEventName["CREATE_EVENT_FROM_SCHEDULE_EXPERIENCE_MODAL"] = "Create Event From Schedule Experience Modal";
    MetricsEventName["OPEN_ROR_MODAL"] = "Open RoR Modal";
    MetricsEventName["SWITCH_ROR_SOCIAL_ROOM"] = "Switch RoR Social Room";
    MetricsEventName["OPEN_UPLOAD_LOGO_MODAL"] = "Open Upload Logo Modal";
    MetricsEventName["UPLOAD_LOGO"] = "Upload Logo";
    MetricsEventName["ROR_COPY_INVITE_LINK"] = "RoR Copy Invite Link";
    MetricsEventName["ROR_TUTORIAL_FINISHED"] = "RoR Tutorial Finished";
    MetricsEventName["SHOW_ONBOARDING_V2_MODAL"] = "Show Onboarding V2 Modal";
    MetricsEventName["SHOW_ONBOARDING_V3_MODAL"] = "Show Onboarding V3 Modal";
    MetricsEventName["CLICK_ONBOARDING_V2_TUTORIAL_BUTTON"] = "Click Onboarding V2 Tutorial Button";
    MetricsEventName["CLICK_ONBOARDING_V3_TUTORIAL_BUTTON"] = "Click Onboarding V3 Tutorial Button";
    MetricsEventName["OPENED_RW_TIPS_GUIDE"] = "Opened RW Tips Guide";
    MetricsEventName["OPENED_RW_ALLHANDS_GUIDE"] = "Opened RW All-Hands Guide";
    MetricsEventName["AUTO_PLACED_RW_GUIDE_OBJECT"] = "Auto Placed RW Guide Object";
    MetricsEventName["SELECTED_RW_36_MAP"] = "Selected RW 36 Map";
    MetricsEventName["AUTO_REMOVED_ROR_OBJECT"] = "Auto Removed ROR Object";
    MetricsEventName["EXIT_SCREEN_BUTTON_PRESSED"] = "Exit Screen Button Pressed";
    MetricsEventName["EXIT_SCREEN_RATING"] = "Exit Screen Rating";
    MetricsEventName["EXIT_SCREEN_REJOIN_SPACE"] = "Exit Screen Rejoin Space";
    MetricsEventName["EXIT_SCREEN_GO_HOME"] = "Exit Screen Go Home";
    MetricsEventName["OPEN_HELP_MODAL"] = "Open Help Modal";
    MetricsEventName["OPEN_HELP_CENTER"] = "Open Help Center";
    MetricsEventName["OPEN_CONTACT_SUPPORT"] = "Open Contact Support";
    MetricsEventName["SEND_SUPPORT_MESSSAGE"] = "Send Support Message";
    MetricsEventName["OPEN_SCHEDULE_DEMO"] = "Open Schedule Demo";
    MetricsEventName["OPEN_LEAVE_FEEDBACK"] = "Open Leave Feedback";
    MetricsEventName["OPEN_OUR_MISSION"] = "Open Our Mission";
    MetricsEventName["OPEN_KEYBOARD_SHORTCUTS"] = "Open Keyboard Shortcuts";
    MetricsEventName["OPEN_WHATS_NEW"] = "Open What's New";
    MetricsEventName["OPEN_JOIN_POWER_USERS"] = "Open Join Power Users";
    MetricsEventName["SHOWN_AV_ISSUES_MODAL"] = "Shown AV Issues Modal";
    MetricsEventName["NO_AV_ISSUE_OBSERVED"] = "No AV Issue Observed";
    MetricsEventName["AV_ERROR_POPUP"] = "av-error-popup";
    MetricsEventName["WIZARD_USE_CASE_PAGE_VIEWED"] = "Wizard Use Case Page Viewed";
    MetricsEventName["WIZARD_CLICK_USE_CASE"] = "Wizard Click Use Case";
    MetricsEventName["WIZARD_SELECT_USE_CASE"] = "Wizard Select Use Case";
    MetricsEventName["WIZARD_SPACE_CONFIGURATION_PAGE_VIEWED"] = "Wizard Space Configuration Page Viewed";
    MetricsEventName["WIZARD_SELECT_SIZE"] = "Wizard Select Size";
    MetricsEventName["WIZARD_SPACE_CONFIGURATION_SELECTION_CONFIRMED"] = "Wizard Space Configuration Selection Confirmed";
    MetricsEventName["WIZARD_SPACE_NAME_PAGE_VIEWED"] = "Wizard Space Name Page Viewed";
    MetricsEventName["WIZARD_SELECT_NAME"] = "Wizard Select Name";
    MetricsEventName["WIZARD_PASSWORD_PROTECT_TOGGLED"] = "Wizard Password Protect Toggled";
    MetricsEventName["WIZARD_SIGN_IN_COMPLETE"] = "Wizard Sign In Complete";
    MetricsEventName["WIZARD_SELECT_CREATE_OR_EXPLORE"] = "Wizard Select Create or Discover";
    MetricsEventName["WIZARD_START_FROM_SCRATCH"] = "Wizard Click Start from scratch";
    MetricsEventName["WIZARD_SELECT_RW_USE_CASE"] = "Wizard Select RW Use Case";
    MetricsEventName["WIZARD_SELECT_SOCIAL"] = "Wizard Select Social";
    MetricsEventName["CREATE_SPACE_INVITE_PAGE_VIEWED"] = "Create Space Invite Page Viewed";
    MetricsEventName["CREATE_SPACE_INVITE_COPY_LINK_CLICKED"] = "Create Space Invite Copy Link Clicked";
    MetricsEventName["CREATE_SPACE_INVITE_EMAIL_FIELD_INTERACTED"] = "Create Space Invite Email Field Interacted";
    MetricsEventName["CREATE_SPACE_INVITE_NEXT_CLICKED"] = "Create Space Invite Next Clicked";
    MetricsEventName["CREATE_SPACE_INVITE_HOME_CLICKED"] = "Create Space Invite Home Clicked";
    MetricsEventName["MULTIPLE_DOMAINS_ACCESS_SAVE"] = "Multiple Domains Save";
    MetricsEventName["HOST_PINNED_MESSAGE_POST"] = "Host Pinned Message Post";
    MetricsEventName["HOST_PINNED_MESSAGE_DELETE"] = "Host Pinned Message Delete";
    MetricsEventName["HOST_ANNOUNCEMENT_POST"] = "Host Announcement Post";
    MetricsEventName["ATTENDEE_ANNOUNCEMENT_DISMISS"] = "Attendee Announcement Dismiss";
    MetricsEventName["ATTENDEE_ANNOUNCEMENT_TIMEOUT"] = "Attendee Announcement Timeout";
    MetricsEventName["ATTENDEE_OPEN_INFORMATION_BOARD"] = "Attendee Open Information Board";
    MetricsEventName["ATTENDEE_OPEN_INFORMATION_BOARD_UNREAD_ANNOUNCEMENTS"] = "Attendee Open Information Board View Unread Announcements";
    MetricsEventName["VISIT_EXPLORE_PAGE"] = "Visit Explore Page";
    MetricsEventName["CLICK_EXPLORE_TAB"] = "Click on Explore Tab";
    MetricsEventName["CLICK_EXPLORE_CATEGORY"] = "Click on Explore Category";
    MetricsEventName["CLICK_SPACE_CARD"] = "Click on Space Card";
    MetricsEventName["CLICK_SPACE_CARD_INFO_BUTTON"] = "Click on Space Card Info Button";
    MetricsEventName["CLICK_SPACE_INFO_MODAL_ENTER_SPACE_BUTTON"] = "Click on Space Info Modal Enter Space Button";
    MetricsEventName["CLICK_SPACE_CARD_MENU_BUTTON"] = "Click on Space Card Menu Button";
    MetricsEventName["CLICK_SPACE_CARD_MENU_OPTION"] = "Click on Space Card Menu Option";
    MetricsEventName["EVENT__CLICK_EVENT_TAB"] = "Click on Event Tab";
    MetricsEventName["EVENT__CLICK_CREATE_EVENT"] = "Event: Click on Create Event";
    MetricsEventName["EVENT__LANDED_ON_SIGN_IN_WALL"] = "Event: Landed on Sign In Wall";
    MetricsEventName["EVENT__COMPLETED_SIGN_IN_WALL"] = "Event: Completed Sign In Wall";
    MetricsEventName["EVENT__CLICK_CREATE_SPACE_TOP_BAR"] = "Click on Top Bar Button to Create Space";
    MetricsEventName["EVENT__CLICK_CREATE_EVENT_TOP_BAR"] = "Event: Click on Top Bar Button to Create Event Page";
    MetricsEventName["EVENT__CLICK_SIGN_IN"] = "Event: Click on Sign In";
    MetricsEventName["EVENT__DETAILS_BACK_BUTTON"] = "Event: Click on back button from details page";
    MetricsEventName["EVENTS__MODAL_BACK_TO_EXPLORE"] = "Event: Click back to explore on get-started";
    MetricsEventName["EVENT__CLICK_DISCARD_CHANGES"] = "Event: Click on Discard changes";
    MetricsEventName["EVENT__SAVE_DETAILS"] = "Event: Save Details";
    MetricsEventName["EVENT__DETAILS_FOCUS"] = "Event: Focus on a details field";
    MetricsEventName["EVENT__LANDING_PAGE_FOCUS"] = "Event: Focus on a landing page setup field";
    MetricsEventName["EVENT__LANDING_PAGE_SAVE_EVENT"] = "Landing page: add to user saved events";
    MetricsEventName["EVENT__LANDING_PAGE_REMOVE_EVENT"] = "Landing page: remove from user saved events";
    MetricsEventName["EVENT__CHECKLIST_EDIT_DETAILS"] = "Checklist: Click on Edit Details";
    MetricsEventName["EVENT__CHECKLIST_EDIT_LANDING_PAGE"] = "Checklist: Click on Edit Landing Page";
    MetricsEventName["EVENT__CHECKLIST_EDIT_SESSIONS"] = "Checklist: Click on Add Session";
    MetricsEventName["EVENT__CHECKLIST_CREATE_SPACE"] = "Checklist: Create space";
    MetricsEventName["EVENT__CHECKLIST_CHANGE_SPACE"] = "Checklist: Change space";
    MetricsEventName["EVENT__CHECKLIST_OPEN_MAPMAKER"] = "Checklist: Customize space using mapmaker";
    MetricsEventName["EVENT__CHECKLIST_MANAGE_SPACE"] = "Checklist: Open dashboard to manage space";
    MetricsEventName["EVENT__CHECKLIST_ENTER_SPACE"] = "Checklist: Click on Enter Space";
    MetricsEventName["EVENT__CHECKLIST_INVITE_COLABORATORS"] = "Checklist: Click on Invite Collaborators";
    MetricsEventName["EVENT__CHECKLIST_ADD_COLABORATOR"] = "Checklist: Click on Add Collaborator";
    MetricsEventName["EVENT__UPLOAD_IMAGE"] = "Event: Upload an image";
    MetricsEventName["EVENT__SAVE_LANDING_PAGE"] = "Event: Save landing page";
    MetricsEventName["EVENT__PREVIEW_PAGE"] = "Event: Preview page";
    MetricsEventName["EVENT__ADD_SESSION"] = "Event: Click add session";
    MetricsEventName["EVENT__CREATE_NEW_LOCATION"] = "Event: Create a new location in the space for a session";
    MetricsEventName["EVENT__PUBLISH"] = "Event: Publish Event";
    MetricsEventName["EVENT__PUBLISH_CLICK_PREVIEW"] = "Event: Publish Click Preview";
    MetricsEventName["EVENT__VIEW_EVENT"] = "Event: Click on view event link";
    MetricsEventName["EVENT__DELETE_EVENT"] = "Event: Delete Event";
    MetricsEventName["EVENT__SHARE"] = "Event: Share the event";
    MetricsEventName["EVENT__CALENDAR_ADD"] = "Event: Calendar add";
    MetricsEventName["EVENT__SANDBOX_DEMO"] = "Event: Try Gather Clicks";
    MetricsEventName["EVENT__GO_TO_ROOM"] = "Event: Room clicks";
    MetricsEventName["EVENT__CLICKS"] = "Event: Go To Event clicks";
    MetricsEventName["EVENT__ON_PAGE"] = "Event: Landed on a page";
    MetricsEventName["EVENT__LIST_SIGN_IN"] = "Events list: render sign in";
    MetricsEventName["EVENT__SPACE_PICK_TEMPLATE"] = "Select space: click pick a template";
    MetricsEventName["EVENT__SPACE_LINK_EXISTING"] = "Select space: click link to existing";
    MetricsEventName["EVENT__SPACE_PARTNERS"] = "Select space: click partners";
    MetricsEventName["EVENT__SPACE_CREATED_SPACE"] = "Space created";
    MetricsEventName["EVENT__SPACE_SELECTED_SPACE"] = "Space selected";
    MetricsEventName["EVENT__SPACE_CATEGORY"] = "Create space: category selected";
    MetricsEventName["EVENT__SPACE_TEMPLATE"] = "Create space: template selected";
    MetricsEventName["EVENT__CHECKLIST_CUSTOMIZE_SPACE_EDITS"] = "Checklist: space has been customized";
    MetricsEventName["EVENT__CHECKLIST_MAKE_RESERVATION_EDITS"] = "Checklist:reservation has been made";
    MetricsEventName["EVENT__CHECKLIST_INVITE_TEAM_EDITS"] = "Checklist: invite your team updates";
    MetricsEventName["EVENT__CHECKLIST_SPACE_ACCESS_EDITS"] = "Checklist: space acecss updates";
    MetricsEventName["EVENT__CHECKLIST_INFORMATION_BOARD_EDITS"] = "Checklist: information board updates";
    MetricsEventName["EVENT__CHECKLIST_SHOW"] = "Checklist: show original checklist";
    MetricsEventName["EVENT__CHECKLIST_SHORT_SHOW"] = "Checklist: show shorter checklist";
    MetricsEventName["EVENT__CHECKLIST_MAKE_RESERVATION"] = "Checklist: click on Make a Reservation";
    MetricsEventName["EVENT__PUBLISH_PREVIEW_SPACE"] = "Checklist: click on Preview Space of publish preview";
    MetricsEventName["EVENT__PUBLISH_PREVIEW_LANDING_PAGE"] = "Checklist: click on Preview Landing Page of publish preview";
    MetricsEventName["EVENT__PUBLISH_MANAGE_RESERVATION"] = "Checklist: click on Manage Reservation of publish preview";
    MetricsEventName["EVENT__SESSIONS_ADD_SESSION"] = "Sessions: add session";
    MetricsEventName["EVENT__SESSIONS_CREATE_SESSION"] = "Sessions: created session";
    MetricsEventName["EVENT__SESSIONS_REMOVE_SESSION"] = "Sessions: remove session";
    MetricsEventName["EVENT__SESSIONS_EDIT_SESSION"] = "Sessions: edit session";
    MetricsEventName["EVENT__SESSIONS_UPDATE_SESSION"] = "Sessions: updated session";
    MetricsEventName["EVENT__SESSIONS_SHOW_ADD_SPEAKER_MODAL"] = "Sessions: open add speaker modal";
    MetricsEventName["EVENT__SESSIONS_ADD_SPEAKER"] = "Sessions: add new speaker";
    MetricsEventName["EVENT__DASHBOARD_SHOW_ADD_SPEAKER_MODAL"] = "Dashboard: open add speaker modal";
    MetricsEventName["EVENT__DASHBOARD_SAVE_SPEAKER_DATA"] = "Dashboard: save speaker data";
    MetricsEventName["EVENT__DASHBOARD_REMOVE_SPEAKER"] = "Dashboard: remove speaker";
    MetricsEventName["EVENT__DASHBOARD_SHOW_EDIT_SPEAKER_MODAL"] = "Dashboard: show edit speaker modal";
    MetricsEventName["EVENT_SEAKER_SIGN_IN"] = "Speaker: first sign in";
    MetricsEventName["EVENT_SEAKER_EDIT_AVATAR"] = "Speaker: click edit avatar";
    MetricsEventName["EVENT_SEAKER_FINISH_PROFILE"] = "Speaker: click finish profile";
    MetricsEventName["EVENT__MAP_CUSTOM_CHANGE_TYPE"] = "Map customization: change event type";
    MetricsEventName["EVENT__MAP_CUSTOM_CHANGE_CATEGORY"] = "Map customization: change category";
    MetricsEventName["EVENT__MAP_CUSTOM_CHANGE_ACCESS"] = "Map customization: change internal/external";
    MetricsEventName["EVENT__MAP_CUSTOM_CHANGE_PARTICIPANTS"] = "Map customization: change number of participants";
    MetricsEventName["EVENT__MAP_CUSTOM_LINK_OR_CREATE_SPACE"] = "Map customization: click on link or create space";
    MetricsEventName["EVENT__MAP_CUSTOM_CREATE_ROOMS"] = "Map customization: rooms selected";
    MetricsEventName["EVENT__MAP_CUSTOM_CREATE_SPACE"] = "Map customization: create space";
    MetricsEventName["EVENT__MAP_CUSTOM_CREATE_EVENT"] = "Map customization: create event";
    MetricsEventName["EVENT__SCHEDULE_SELECT_SESSION"] = "Event Schedule: select session";
    MetricsEventName["EVENT__SCHEDULE_LOCATE_PATH_TO_SESSION"] = "Event Schedule: locate path to session";
    MetricsEventName["EVENT__CHAT_SEND_MESSAGE"] = "Event chat: send message";
    MetricsEventName["EVENT__CHAT_UPVOTE_MESSAGE"] = "Event chat: upvote message";
    MetricsEventName["EVENT__CHAT_REPLY_QA"] = "Event chat: reply q&a";
    MetricsEventName["MINIMAP__CLOSE"] = "Minimap: Close via X";
    MetricsEventName["MINIMAP__OPEN"] = "Minimap: Open via icon";
    MetricsEventName["MINIMAP__TOOLTIP_CLOSE_VIA_X"] = "Minimap: Close tooltip via X";
    MetricsEventName["MINIMAP__TOOLTIP_CLOSE_VIA_CLUSTER"] = "Minimap: Close tooltip via click on cluster";
    MetricsEventName["MINIMAP__CLICK_ON_CLUSTER"] = "Minimap: Click on cluster";
    MetricsEventName["MINIMAP__EXPAND"] = "Minimap: Expand to fullscreen";
    MetricsEventName["MOBILE_BUSY_MODE"] = "Mobile busy mode";
    MetricsEventName["MOBILE_AUDIO_ONLY_MODE"] = "Mobile audio only mode";
    MetricsEventName["MOBILE_APP_COLD_START"] = "Mobile app: Cold start";
    MetricsEventName["MOBILE_APP_HOT_START"] = "Mobile app: Hot start";
    MetricsEventName["MOBILE_APP_OPEN_SETTINGS"] = "Mobile app: Open settings";
    MetricsEventName["MOBILE_APP_JOIN_MEETING_FROM_CALENDAR_LIST"] = "Mobile app: Join meeting from calendar list";
    MetricsEventName["MOBILE_APP_START_INSTANT_MEETING"] = "Mobile app: Start instant meeting";
    MetricsEventName["MOBILE_APP_TOGGLE_NOTIFICATIONS"] = "Mobile app: Toggle notifications";
    MetricsEventName["MOBILE_APP_JOIN_LINK_UNSUCCESSFUL"] = "Mobile app: Join link unsuccessful";
    MetricsEventName["MOBILE_APP_OPEN_PARTICIPANTS_TAB"] = "Mobile app: Open participants tab";
    MetricsEventName["MOBILE_APP_JOIN_MEETING_FROM_PARTICIPANTS_PANEL"] = "Mobile app: Join meeting from participants panel";
    MetricsEventName["MOBILE_APP_REQUEST_TO_MEET_INITIATED"] = "Mobile app: Request to meet initiated";
    MetricsEventName["MOBILE_PUSH_SHOWN_MODAL"] = "Mobile push: Shown modal";
    MetricsEventName["MOBILE_PUSH_QR_SCANNED"] = "Mobile push: QR scanned";
    MetricsEventName["MOBILE_REDIRECT_SHOWN"] = "Mobile redirect: Shown";
    MetricsEventName["MOBILE_REDIRECT_GET_APP_CLICKED"] = "Mobile redirect: Clicked";
    MetricsEventName["MOBILE_REDIRECT_CONTINUE_IN_BROWSER_CLICKED"] = "Mobile redirect: Clicked";
    MetricsEventName["START_ESCAPE_ROOM"] = "Start Escape Room";
    MetricsEventName["ACTIVATE_PHOTO_MODE"] = "Activate Photo Mode";
    MetricsEventName["TAKE_PHOTO"] = "Take Photo";
    MetricsEventName["DOWNLOAD_PHOTO_MODE"] = "Click Download in Photo Mode";
    MetricsEventName["CLICK_SHARE_PHOTO_MODE"] = "Click Share in Photo Mode";
    MetricsEventName["CLICK_SHARE_COPY_RESULTS"] = "Click Share to Copy Escape Room Results";
    MetricsEventName["REMOTE_WORK_SPAWN_PORTAL_LINK_COPIED"] = "Remote Work Spawn Portal Link Copied";
    MetricsEventName["RWE_TUTORIAL_EVENT_SHOWN"] = "RWE Tutorial Event Shown";
    MetricsEventName["HIP_TO_BE_SQUARE_START"] = "Hip to be square game started";
    MetricsEventName["HIP_TO_BE_SQUARE_NEXT_ROUND"] = "Hip to be square next round";
    MetricsEventName["HIP_TO_BE_SQUARE_END"] = "Hip to be square game end";
    MetricsEventName["MEETING_NO_LOCATION_FOUND"] = "Meetings: No private area available";
    MetricsEventName["MEETINGS_JOINED_MEETING_LINK"] = "Meetings: Joined meeting link";
    MetricsEventName["MEETINGS_SELECTED_EXTENSION_SPACE"] = "Meetings: Select space for browser extension";
    MetricsEventName["MEETINGS_CLICKED_EXTENSION_BANNER"] = "Meetings: Click browser extension install banner";
    MetricsEventName["MEETINGS_CLICKED_MSOFFICE_ADDIN_BANNER"] = "Meetings: Click MSOffice addin install banner";
    MetricsEventName["MEETINGS_CLICKED_TAKE_ME_THERE"] = "Meetings: Clicked 'Take Me There' button";
    MetricsEventName["MEETINGS_LOCK_PRIVATE_AREA"] = "Meetings: Lock Private Area";
    MetricsEventName["MEETINGS_CLICK_MEET_IN_GATHER"] = "Meeting: Click meet in Gather";
    MetricsEventName["MEETINGS_NAV_CLICKED_MEETING_INFO"] = "Meetings nav: Clicked to view meeting info";
    MetricsEventName["MEETINGS_NAV_VIEWED_EVENT_DETAILS"] = "Meetings nav: Viewed event details";
    MetricsEventName["MEETINGS_NAV_COPIED_MEETING_LINK"] = "Meetings nav: Copied meeting link in nav";
    MetricsEventName["RW_WIZARD_OFFICE_CONFIGURATION_MAP_SWITCH"] = "RW wizard office configuration map switch";
    MetricsEventName["RW_OFFICE_CONFIGURATION_MAP_SWITCH"] = "RW office configuration map switch";
    MetricsEventName["RW_OFFICE_CONFIGURATION_MAP_RESTORE"] = "RW office configuration map restore";
    MetricsEventName["JOINING_WITH_SPAWN_TOKEN"] = "Joining with spawn token";
    MetricsEventName["ADD_SLACK_INTEGRATION"] = "Slack: Add Slack integration";
    MetricsEventName["REMOVE_SLACK_INTEGRATION"] = "Slack: Remove Slack integration";
    MetricsEventName["USE_SLACK_COMMAND"] = "Slack: Use Slack command";
    MetricsEventName["SELECT_SLACK_CAPACITY"] = "Slack: Select Slack capacity";
    MetricsEventName["CLICK_SLACK_MEETING_LINK"] = "Slack: Click Slack meeting link";
    MetricsEventName["MIGRATE_RECURRING_MEETINGS"] = "Recurring meetings: Migrate meetings";
    MetricsEventName["FIND_RECURRING_MEETINGS"] = "Recurring meetings: Find meetings";
    MetricsEventName["CTA_RECURRING_MEETINGS"] = "Recurring meetings: Click on events banner";
    MetricsEventName["INLINE_CTA_RECURRING_MEETINGS"] = "Recurring meetings: Migrate from inline event";
    MetricsEventName["RW_TEAM_INVITE_SEND_INVITES"] = "RW Team invite: send email invites";
    MetricsEventName["RW_TEAM_INVITE_UPGRADE_SPACE"] = "RW Team invite: upgrade space";
    MetricsEventName["RW_TEAM_INVITE_INVITE_USED"] = "RW Team invite: user used link to join space";
    MetricsEventName["RW_TEAM_INVITE_CLAIM_DESK"] = "RW Team invite: claimed desk from link";
    MetricsEventName["RW_TEAM_INVITE_CLAIM_DESK_NOT_AVAILABLE"] = "RW Team invite: desk to be claimed from link had already been claimed";
    MetricsEventName["RW_TEAM_INVITE_COPIED_LINK_TO_CLIPBOARD"] = "RW Team invite: copied link to clipboard";
    MetricsEventName["RW_TEAM_INVITE_OPEN_EXPAND_SPACE"] = "RW Team invite: open expand space";
    MetricsEventName["RW_CLAIM_DESK"] = "Desks: Claim";
    MetricsEventName["RW_UNCLAIM_DESK"] = "Desks: Unclaim";
    MetricsEventName["RW_DESK_BUILD_SWITCH_OBJECT"] = "Desks: Switch Object";
    MetricsEventName["RW_DESK_BUILD_REMOVE_OBJECT"] = "Desks: Remove Object";
    MetricsEventName["RW_DESK_BUILD_DRAG_OBJECT"] = "Desks: Drag Object";
    MetricsEventName["RW_SEND_WAVE"] = "Send Wave";
    MetricsEventName["RW_DESK_CLICK_GIFT_ICON"] = "Desks: Click Gift Icon";
    MetricsEventName["RW_DESK_COMPOSE_GIFT"] = "Desks: Compose Gift";
    MetricsEventName["RW_DESK_PLACE_GIFT"] = "Desks: Place Gift";
    MetricsEventName["RW_DESK_GIFT_REACT"] = "Desks: Gift React";
    MetricsEventName["RW_DESK_GIFT_CLEAN_UP"] = "Desks: Gift Clean Up";
    MetricsEventName["RW_DESK_GIFT_AUTO_CLEAN_UP"] = "Desks: Gift Auto Clean Up";
    MetricsEventName["RW_VIEW_PROFILE_CLICKED"] = "View Profile Clicked";
    MetricsEventName["RW_OPEN_BUILD_CLICKED"] = "Open Build Clicked";
    MetricsEventName["RW_PROFILE_VIEW"] = "Profile: View";
    MetricsEventName["RW_PROFILE_START_EDITING_SEGMENT"] = "Profile: Start Editing Segment";
    MetricsEventName["RW_PROFILE_SAVE_FIELDS"] = "Profile: Save Fields";
    MetricsEventName["UPLOAD_IMAGE_MAXIMUM_FILE_SIZE_EXCEEDED"] = "Upload Image Maximum File Size Exceeded";
    MetricsEventName["SPACE_AT_CAPACITY_WARNS_ADMIN_USER"] = "Space capacity: Admin user acknowledges space at cap notification";
    MetricsEventName["SPACE_OVER_CAPACITY_WARNS_ADMIN_USER"] = "Space capacity: Admin user acknowledges space over cap notification";
    MetricsEventName["SPACE_OVER_CAPACITY_DENIES_USER"] = "Space capacity: User denied entry due to capacity";
    MetricsEventName["SPACE_OVER_CAPACITY_WARNS_ADMIN_USER_DENIED"] = "Space capacity: Admin user acknowledges user denied entry notification";
    MetricsEventName["SPACE_OVER_CAPACITY_WARNS_NON_ADMIN_USER_DENIED"] = "Space capacity: Non-admin user acknowledges user denied entry notification";
    MetricsEventName["SPACE_CAPACITY_INFO_SHOWN_IN_GRAPES_MENU"] = "Space capacity: Admin user sees capacity info in Grapes menu";
    MetricsEventName["SPACE_CAPACITY_WARNING_UPGRADE_BUTTON_CLICKED"] = "Space capacity: Admin user clicks Upgrade Space button";
    MetricsEventName["SPACE_CAPACITY_WARNING_INCREASE_CAP_BUTTON_CLICKED"] = "Space capacity: Admin user clicks Manage/Increase Capacity button";
    MetricsEventName["NEW_SUBSCRIPTION_SURVEY_START"] = "New subscription survey: Start";
    MetricsEventName["NEW_SUBSCRIPTION_SURVEY_COMPANY_ROLE"] = "New subscription survey: Company role";
    MetricsEventName["NEW_SUBSCRIPTION_SURVEY_COMPANY_SIZE"] = "New subscription survey: Company size";
    MetricsEventName["NEW_SUBSCRIPTION_SURVEY_REMOTE_WORK_CULTURE"] = "New subscription survey: Remote work culture";
    MetricsEventName["NEW_SUBSCRIPTION_SURVEY_INTENDED_USE"] = "New subscription survey: Intended use";
    MetricsEventName["NEW_SUBSCRIPTION_SURVEY_COMPANY_PROBLEMS"] = "New subscription survey: Company problems";
    MetricsEventName["NEW_SUBSCRIPTION_SURVEY_SUBMIT"] = "New subscription survey: Submit";
    MetricsEventName["GUEST_EXPERIENCE_TOGGLE_FROM_SETTINGS"] = "Guest Experience: Admin enabled or disabled Guest Check In from settings";
    MetricsEventName["GUEST_EXPERIENCE_ADMIN_SHOWN_EDU"] = "Guest Experience: Admin was shown user education modal";
    MetricsEventName["GUEST_EXPERIENCE_ADMIN_RESPOND_TO_OPT_IN_EDU"] = "Guest Experience: Admin responded to opt-in user education";
    MetricsEventName["GUEST_EXPERIENCE_INIT_GUEST_CHECK_IN"] = "Guest Experience: Guest shown check in screen";
    MetricsEventName["GUEST_EXPERIENCE_GUEST_SELECTS_MEMBER"] = "Guest Experience: Guest selects member to check in";
    MetricsEventName["GUEST_EXPERIENCE_GUEST_CANCELS_CHECK_IN"] = "Guest Experience: Guest cancels check in";
    MetricsEventName["GUEST_EXPERIENCE_GUEST_CHECK_IN_RESPONSE"] = "Guest Experience: Guest admitted or denied check in";
    MetricsEventName["GUEST_EXPERIENCE_GUEST_PASS_MODAL_OPENED"] = "Guest Experience: Space member opened Guest Pass modal";
    MetricsEventName["GUEST_EXPERIENCE_GUEST_PASS_GRANTED"] = "Guest Experience: Guest Pass granted to user";
    MetricsEventName["GUEST_EXPERIENCE_GUEST_PASS_REVOKED"] = "Guest Experience: Guest Pass revoked from user";
    MetricsEventName["GUEST_EXPERIENCE_GUEST_PROMOTED_TO_MEMBER"] = "Guest Experience: Guest promoted to member";
    MetricsEventName["GUEST_EXPERIENCE_HOST_ADMITS_GUEST"] = "Guest Experience: Host admits guest";
    MetricsEventName["GUEST_EXPERIENCE_GUEST_JOINS_MEETING"] = "Guest Experience: Guest joins meeting";
    MetricsEventName["ENTER_WITH_TEAMMATES_USER_ENTERED_LOBBY"] = "Enter with Teammates: User entered lobby";
    MetricsEventName["ENTER_WITH_TEAMMATES_HOST_CLICKED_INVITE"] = "Enter with Teammates: Host clicked invite button";
    MetricsEventName["ENTER_WITH_TEAMMATES_HOST_CLICKED_ENTER_SPACE"] = "Enter with Teammates: Host clicked enter space";
    MetricsEventName["ENTER_WITH_TEAMMATES_USER_WALKED_TO_DESK"] = "Enter with Teammates: User walked to desk";
    MetricsEventName["ENTER_WITH_TEAMMATES_USER_COMPLETE_EDUCATION_MODAL"] = "Enter with Teammates: User completed education modal";
    MetricsEventName["ENTER_WITH_TEAMMATES_HOST_ENTERED_ALONE"] = "Enter with Teammates: Host entered alone";
    MetricsEventName["ENTER_WITH_TEAMMATES_GUEST_ENTERED_WITHOUT_HOST"] = "Enter with Teammates: Guest entered without host";
    MetricsEventName["FREE_TRIAL_FORM_STARTED"] = "Free Trial Form: Started";
    MetricsEventName["FREE_TRIAL_FORM_COMPLETED"] = "Free Trial Form: Completed";
    MetricsEventName["FREE_TRIAL_FORM_CLOSED"] = "Free Trial Form: Closed";
    MetricsEventName["FREE_TRIAL_UPGRADE_SPACE"] = "Free Trial: Upgrade space click on free trial expire notice";
    MetricsEventName["FREE_TRIAL_AUTO_STARTED"] = "Free Trial: Auto Started";
    MetricsEventName["FREE_TRIAL_NOTICE_MODAL_APPEARED"] = "Free Trial: Notice modal appeared";
    MetricsEventName["FREE_TRIAL_EXPIRED_NOTICE_MODAL_APPEARED"] = "Free Trial Expired: Notice modal appeared";
    MetricsEventName["FREE_TRIAL_NOTICE_ACKNOWLEDGED"] = "Free Trial: Notice modal acknowledged";
    MetricsEventName["FREE_TRIAL_LEARN_HOW_TO_ONBOARD_CLICKED"] = "Free Trial: Learn how to onboard your team clicked";
    MetricsEventName["FREE_TRIAL_UPGRADE_PLAN_CLICKED"] = "Free Trial: Upgrade your plan clicked";
    MetricsEventName["NATIVE_OS_NOTIFICATION_CLICKED"] = "Native OS notification clicked";
    MetricsEventName["SETTING_CHANGED"] = "Setting changed";
    MetricsEventName["USER_CALENDAR_EVENTS"] = "User calendar events updated";
    MetricsEventName["VIDEO_EFFECT_SELECTED"] = "Video effects: New effect selected";
    MetricsEventName["VIRTUAL_BACKGROUND_UPLOADED"] = "Video effects: Custom virtual background uploaded";
    MetricsEventName["VIRTUAL_BACKGROUND_DELETED"] = "Video effects: Custom virtual background deleted";
    MetricsEventName["STANDARD_NOISE_SUPPRESSION_TOGGLED"] = "Standard Browser Noise Suppression Toggled";
    MetricsEventName["KRISP_NOISE_REDUCTION_TOGGLED"] = "Krisp Noise Reduction Toggled";
    MetricsEventName["CLICK_TO_OPEN_CHAT"] = "Click to open chat";
    MetricsEventName["SEND_CHAT_MESSAGE"] = "Send chat message";
    MetricsEventName["CHANGE_STATUS"] = "Change status";
    MetricsEventName["CHANGE_TEXT_STATUS"] = "Change text status";
    MetricsEventName["MINIMODE_CLICK_CHAT"] = "MiniMode: click chat";
    MetricsEventName["MINIMODE_MOVE_WINDOW"] = "MiniMode: move window";
    MetricsEventName["MINIMODE_VIDEO_VIEW"] = "MiniMode: time spent in video view";
    MetricsEventName["MINIMODE_DESK_VIEW"] = "MiniMode: time spent in desk view with players nearby";
    MetricsEventName["MINIMODE_CLICK_PLAYER_CARD"] = "MiniMode: click player card";
    MetricsEventName["MINIMODE_ENTER"] = "MiniMode: enter mini mode";
    MetricsEventName["SPACE_CREATOR_ONBOARDING_STEP_VIEWED"] = "Space Creator Onboarding: Step Viewed";
    MetricsEventName["SPACE_CREATOR_ONBOARDING_STEP_SKIPPED"] = "Space Creator Onboarding: Step Skipped";
    MetricsEventName["SPACE_CREATOR_ONBOARDING_STEP_COMPLETED"] = "Space Creator Onboarding: Step Completed";
    MetricsEventName["SPACE_CREATOR_ONBOARDING_ALL_SKIPPED"] = "Space Creator Onboarding: All onboarding skipped";
    MetricsEventName["SPACE_CREATOR_ONBOARDING_SURVEY_RESPONDED"] = "Space Creator Onboarding: Survey Responded";
    MetricsEventName["SPACE_CREATOR_ONBOARDING_CREATE_SPACE_CLICKED"] = "Space Creator Onboarding: Create space clicked";
    MetricsEventName["SPACE_CREATE_ONBOARDING_SURVEY_LANDED"] = "Space Creator Onboarding: Survey landed";
    MetricsEventName["TAB_DISCARDED"] = "TAB_DISCARDED";
    MetricsEventName["REJOINED_SPACE"] = "Rejoined space";
    MetricsEventName["REJOIN_REMINDER_SHOWN"] = "Rejoin reminder shown";
    MetricsEventName["REJOIN_REMINDER_USED_TO_REJOIN"] = "Rejoin reminder used to rejoin";
    MetricsEventName["LEFT_SPACE"] = "Left space";
    MetricsEventName["QUIT_MODAL_SHOWN"] = "Quit modal shown";
    MetricsEventName["TEST_AB_TESTING_AND_METRICS_USER"] = "Test AB Testing and Metrics User";
    MetricsEventName["TEST_AB_TESTING_AND_METRICS_SPACE"] = "Test AB Testing and Metrics Space";
    MetricsEventName["DESKTOP_PUSH_REDIRECT_VIEWED"] = "Desktop push redirect viewed";
    MetricsEventName["DESKTOP_PUSH_REDIRECT_CLICKED"] = "Desktop push redirect download clicked";
    MetricsEventName["DESKTOP_PUSH_REDIRECT_DISMISSED"] = "Desktop push redirect dismissed";
    MetricsEventName["DESKTOP_PUSH_CALENDAR_VIEWED"] = "Desktop push calendar viewed";
    MetricsEventName["DESKTOP_PUSH_CALENDAR_CLICKED"] = "Desktop push calendar clicked";
    MetricsEventName["DESKTOP_PUSH_CALENDAR_DISMISSED"] = "Desktop push calendar dismissed";
    MetricsEventName["DESKTOP_PUSH_GRAPES_CLICKED"] = "Desktop push grapes clicked";
    MetricsEventName["DESKTOP_WINDOWS_7_8_MODAL_SHOWN"] = "Desktop Windows 7 and 8 Warning Modal Shown";
    MetricsEventName["MONTHLY_SUBSCRIPTION_MANAGE"] = "Monthly Subscription: Manage clicked";
    MetricsEventName["MONTHLY_SUBSCRIPTION_UPDATE_CAPACITY"] = "Monthly Subscription: Update capacity clicked";
    MetricsEventName["MONTHLY_SUBSCRIPTION_COMPLETE_CHANGE"] = "Monthly Subscription: Complete change clicked";
    MetricsEventName["MONTHLY_SUBSCRIPTION_CHANGE_COMPLETED"] = "Monthly Subscription: Change completed";
    MetricsEventName["SPACE_DASHBOARD_TAB_VIEWED"] = "Space Dashboard: Tab Viewed";
    MetricsEventName["SPACE_DASHBOARD_INVITE_MEMBERS"] = "Space Dashboard: Invite Members";
    MetricsEventName["SPACE_DASHBOARD_SSO_SETUP_CLICKED"] = "Space Dashboard SSO: Setup Clicked";
    MetricsEventName["SPACE_DASHBOARD_SSO_COPY_SETUP_LINK_CLICKED"] = "Space Dashboard SSO: Copy Setup Link Clicked";
    MetricsEventName["SSO_SETUP_STATUS_CHANGED"] = "SSO: Setup Status Changed";
    MetricsEventName["SSO_USE_SSO_LINK_CLICKED"] = "SSO: Use SSO Link Clicked";
    MetricsEventName["SSO_AUTH_PAGE_VIEWED"] = "SSO: Auth Page Viewed";
    MetricsEventName["SSO_USE_OTHER_METHOD"] = "SSO: Use Other Method Clicked";
    MetricsEventName["SSO_SIGN_IN_CLICKED"] = "SSO: Sign In Clicked";
    MetricsEventName["SSO_SENT_TO_IDP"] = "SSO: Sent to IDP";
    MetricsEventName["SSO_SENT_TO_IDP_FAILED"] = "SSO: Sent to IDP Failed";
    MetricsEventName["SSO_CONNECTION_NOT_FOUND_FOR_EMAIL"] = "SSO: Connection Not Found For Email";
    MetricsEventName["SSO_IDP_AUTH_CALLBACK_PAGE_VIEWED"] = "SSO: IDP Auth Callback Page Viewed";
    MetricsEventName["SSO_AUTH_SUCCESSFUL"] = "SSO: Auth Successful";
    MetricsEventName["SSO_AUTH_FAILED"] = "SSO: Auth Failed";
    MetricsEventName["SSO_REDIRECTED_MEMBER_TO_SSO"] = "SSO: Redirected Member To SSO";
    MetricsEventName["SSO_MERGE_NOTICE_VIEWED"] = "SSO: Merge Notice Viewed";
    MetricsEventName["SSO_MERGE_NOTICE_CONTINUE_CLICKED"] = "SSO: Merge Notice Continue Clicked";
    MetricsEventName["SSO_MERGE_NOTICE_CLOSE_CLICKED"] = "SSO: Merge Notice Close Clicked";
    MetricsEventName["SSO_SESSION_EXPIRED"] = "SSO: Session Expired";
    MetricsEventName["CHROME_EXTENSION_ADD_LINK"] = "Chrome Extension: Add meeting link";
    MetricsEventName["CHROME_EXTENSION_REMOVE_LINK"] = "Chrome Extension: Remove meeting link";
    MetricsEventName["CHROME_EXTENSION_IFRAME_SYNC_USER"] = "Chrome Extension: Iframe Sync User";
    MetricsEventName["CHROME_EXTENSION_IFRAME_LOADED"] = "Chrome Extension: Iframe Loaded";
    MetricsEventName["CHROME_EXTENSION_IFRAME_AREA_SELECTED"] = "Chrome Extension: Area Selected";
    MetricsEventName["MSOFFICE_READY"] = "MSOffice Addin: Ready to load app";
    MetricsEventName["MSOFFICE_APP_LOADED"] = "MSOffice Addin: App loaded";
    MetricsEventName["MSOFFICE_ADDIN_SELECT_SPACE_SCREEN_VIEWED"] = "MSOffice Addin: Select Space Screen Viewed";
    MetricsEventName["MSOFFICE_ADDIN_SELECT_MEETING_LOCATION_SCREEN_VIEWED"] = "MSOffice Addin: Select Meeting Location Screen Viewed";
    MetricsEventName["MSOFFICE_ADDIN_SPACE_SELECTED"] = "MSOffice Addin: Space Selected";
    MetricsEventName["MSOFFICE_ADDIN_AREA_SELECTED"] = "MSOffice Addin: Area Selected";
    MetricsEventName["CALENDAR_SIDEBAR_SETTINGS_CHANGE_SPACE_CLICKED"] = "Calendar Sidebar: Settings Change Space Clicked";
    MetricsEventName["AMBIENT_MUTE_ACTIVE_CONVERSATIONS"] = "Ambient: mute active conversations";
    MetricsEventName["AMBIENT_AUDIO_LOCK_DESK"] = "Ambient: audio lock desk";
    MetricsEventName["AMBIENT_ACTION_FEEDBACK"] = "Ambient: Action feedback";
    MetricsEventName["AMBIENT_FIND_PRIVATE_AREA"] = "Ambient: Find private area";
    MetricsEventName["MEMBER_ONBOARDING_STEP_VIEWED"] = "Member Onboarding: Step Viewed";
    MetricsEventName["MEMBER_ONBOARDING_STEP_SKIPPED"] = "Member Onboarding: Step Skipped";
    MetricsEventName["MEMBER_ONBOARDING_STARTED"] = "Member Onboarding: Started";
    MetricsEventName["MEMBER_ONBOARDING_COMPLETED"] = "Member Onboarding: Completed";
    MetricsEventName["MEMBER_ONBOARDING_SELECT_AVATAR"] = "Member Onboarding: Select Avatar";
    MetricsEventName["MEMBER_ONBOARDING_SELECT_DESK"] = "Member Onboarding: Select Desk";
    MetricsEventName["MEMBER_ONBOARDING_DESK_COMPOSE_GIFT"] = "Member Onboarding: Desk Compose Gift";
    MetricsEventName["MEMBER_ONBOARDING_CONNECT_CALENDAR"] = "Member Onboarding: Connect Calendar";
    MetricsEventName["MEMBER_ONBOARDING_CLICK_DOWNLOAD_EXTENSION"] = "Member Onboarding: Click Download Extension";
    MetricsEventName["MEMBER_ONBOARDING_MIGRATE_MEETINGS"] = "Member Onboarding: Migrate Meetings";
    MetricsEventName["MEMBER_ONBOARDING_CLOSE"] = "Member Onboarding: Close";
    MetricsEventName["MEMBER_ONBOARDING_RESUME"] = "Member Onboarding: Resume";
    MetricsEventName["MEMBER_ONBOARDING_TOGGLE_PROGRESS_MENU"] = "Member Onboarding: Toggle Progress Menu";
    MetricsEventName["GATHER_LABS_TOGGLE"] = "GatherLabs: toggled feature";
    MetricsEventName["DESK_POD_EDIT_MODAL_OPENED"] = "Desk Pod Edit Modal Opened";
    MetricsEventName["DESK_POD_NAME_CHANGED"] = "Desk Pod Name Changed";
    MetricsEventName["DESK_POD_MODE_CHANGED"] = "Desk Pod Mode Changed";
    MetricsEventName["MAPMAKER_ADDED_TEXT"] = "Mapmaker: Added text";
    MetricsEventName["MAPMAKER_ADDED_TEXT_V2"] = "Mapmaker: Added text V2";
    MetricsEventName["MAPMAKER_ADDED_UPLOADED_OBJECT"] = "Mapmaker: Added custom object";
    MetricsEventName["MAPMAKER_BOX_SELECT_TOOL_SELECTED"] = "Mapmaker: Selected box select tool";
    MetricsEventName["MAPMAKER_GRAB_TOOL_SELECTED"] = "Mapmaker: Selected grab tool";
    MetricsEventName["MAPMAKER_ERASE_TOOL_SELECTED"] = "Mapmaker: Selected erase tool";
    MetricsEventName["MAPMAKER_SELECT_TOOL_SELECTED"] = "Mapmaker: Selected select tool";
    MetricsEventName["MAPMAKER_STAMP_TOOL_SELECTED"] = "Mapmaker: Selected stamp tool";
    MetricsEventName["MAPMAKER_ZOOM_TOOL_SELECTED"] = "Mapmaker: Selected zoom tool";
    MetricsEventName["MAPMAKER_UPLOADED_BACKGROUND"] = "Mapmaker: Uploaded a background";
    MetricsEventName["MAPMAKER_UPLOADED_FOREGROUND"] = "Mapmaker: Uploaded a foreground";
    MetricsEventName["MAPMAKER_OPENED"] = "Mapmaker: Opened the mapmaker";
    MetricsEventName["MAPMAKER_SAVED"] = "Mapmaker: Saved";
    MetricsEventName["MAPMAKER_CONFLICT_ENCOUNTERED"] = "Mapmaker: Conflict encountered";
    MetricsEventName["MAPMAKER_CONFLICT_DISCARDED_CHANGES"] = "Mapmaker: Conflict discarded changes";
    MetricsEventName["MAPMAKER_CONFLICT_OVERWRITTEN_CHANGES"] = "Mapmaker: Conflict overwritten changes";
    MetricsEventName["MAPMAKER_SAVED_WALLS_FLOORS"] = "Mapmaker: Saved new walls and floors";
    MetricsEventName["MAPMAKER_ADDED_PORTAL"] = "Mapmaker: Added portal";
    MetricsEventName["BUILD_TOOL_ADDED_TEXT"] = "Build Tool: Added text";
    MetricsEventName["CHAT_V2_SEND_MESSAGE"] = "Chat V2: Send message";
    MetricsEventName["CHAT_V2_EDIT_MESSAGE"] = "Chat V2: Edit message";
    MetricsEventName["CHAT_V2_DELETE_MESSAGE"] = "Chat V2: Delete message";
    MetricsEventName["CHAT_V2_CREATE_CHAT"] = "Chat V2: Create chat";
    MetricsEventName["CHAT_V2_TOGGLE_REACTION"] = "Chat V2: Toggle reaction";
    MetricsEventName["CHAT_V2_SEND_ATTACHMENT"] = "Chat V2: Send attachment message";
    MetricsEventName["CHAT_V2_INGRESS"] = "Chat V2: Ingress";
    MetricsEventName["CHAT_V2_NOTIFICATION_REPLY"] = "Chat V2: Replied to a Notification";
    MetricsEventName["STAY_IN_COWORK_AREA_AFTER_INVITATION"] = "Stay in Cowork Area After Invitation";
    MetricsEventName["COWORK_INVITATION_SENT"] = "Cowork invitation sent";
    MetricsEventName["COWORK_STATUS_MESSAGE_CHANGED"] = "Cowork status message changed";
    MetricsEventName["PROMOTE_TO_MEMBER_CLICKED"] = "Promote to member: clicked";
    MetricsEventName["PROMOTE_TO_MEMBER_CONFIRMED"] = "Promote to member: confirmed";
    MetricsEventName["PROMOTE_TO_MEMBER_ANON_ACCEPTED"] = "Promote to member: anonymous user accepted";
    MetricsEventName["WHATS_NEW_SHOWN"] = "Whats New: Shown";
    MetricsEventName["WHATS_NEW_SLIDE_VIEWED"] = "Whats New: Slide Viewed";
    MetricsEventName["WHATS_NEW_CLOSED"] = "Whats New: Closed";
    MetricsEventName["WHATS_NEW_ACTION_PRESSED"] = "Whats New: Action Pressed";
    MetricsEventName["INSIGHTS_PAGE_VIEWED"] = "Insights: Page Viewed";
    MetricsEventName["INSIGHTS_DATE_RANGE_SELECTED"] = "Insights: Date Range Selected";
    MetricsEventName["INSIGHTS_CHART_RENDERED"] = "Insights: Chart Rendered";
    MetricsEventName["INSIGHTS_MEMBERS_CHART_TAB_VIEWED"] = "Insights: Members Chart Tab Viewed";
    MetricsEventName["INSIGHTS_CSV_DOWNLOADED"] = "Insights: CSV Downloaded";
    MetricsEventName["INSIGHTS_PREMIUM_UPSELL_MODAL_VIEWED"] = "Insights: Premium Upsell Modal Viewed";
    MetricsEventName["INSIGHTS_OPENED_FROM_GRAPES_MENU"] = "Insights: Opened From Grapes Menu";
    MetricsEventName["INSIGHTS_WELCOME_BANNER_SHOWN"] = "Insights: Welcome Banner Shown";
    MetricsEventName["INSIGHTS_LOW_DATA_BANNER_SHOWN"] = "Insights: Low Data Banner Shown";
    MetricsEventName["MINIMAL_MODE_ZOOM_IN_CLICK"] = "Minimal Mode: Zoom in";
    MetricsEventName["MINIMAL_MODE_ZOOM_OUT_CLICK"] = "Minimal Mode: Zoom out";
    MetricsEventName["MINIMAL_MODE_SHOW_MY_LOCATION"] = "Minimal Mode: Show my location";
    MetricsEventName["MINIMAL_MODE_SHOW_OFFICE"] = "Minimal Mode: Show office";
    MetricsEventName["INVITE_MORE_TO_MEETING_CLICKED"] = "Invite more to meeting clicked";
    MetricsEventName["INVITE_MORE_TO_MEETING_SENT"] = "Invite more to meeting sent";
    MetricsEventName["REQUEST_TO_UPGRADE_TO_MEMBER"] = "Requested to upgrade to member";
    MetricsEventName["RESPONDED_TO_UPGRADE_TO_MEMBER"] = "Responded to upgrade to member";
    MetricsEventName["CLICK_NUDGE_TO_PENDING_REQUESTS"] = "Click nudge to pending requests";
    MetricsEventName["ScreenAnnotation_StartSession"] = "ScreenAnnotation_StartSession";
    MetricsEventName["ScreenAnnotation_LeaveSession"] = "ScreenAnnotation_LeaveSession";
    MetricsEventName["ScreenAnnotation_EndSession"] = "ScreenAnnotation_EndSession";
    MetricsEventName["ScreenAnnotation_ActivateSession"] = "ScreenAnnotation_ActivateSession";
    MetricsEventName["ScreenAnnotation_DeactivateSession"] = "ScreenAnnotation_DeactivateSession";
    MetricsEventName["ScreenAnnotation_LoadSession"] = "ScreenAnnotation_LoadSession";
    MetricsEventName["ScreenAnnotation_UnloadSession"] = "ScreenAnnotation_UnloadSession";
    MetricsEventName["ScreenAnnotation_ToolbarMounted"] = "ScreenAnnotation_ToolbarMounted";
    MetricsEventName["ScreenAnnotation_SelectTool"] = "ScreenAnnotation_SelectTool";
    MetricsEventName["ScreenAnnotation_SelectColor"] = "ScreenAnnotation_SelectColor";
    MetricsEventName["ScreenAnnotation_SelectStrokeSize"] = "ScreenAnnotation_SelectStrokeSize";
    MetricsEventName["ScreenAnnotation_DrawStart"] = "ScreenAnnotation_DrawStart";
    MetricsEventName["ScreenAnnotation_DrawStop"] = "ScreenAnnotation_DrawStop";
    MetricsEventName["ScreenAnnotation_Undo"] = "ScreenAnnotation_Undo";
    MetricsEventName["ScreenAnnotation_Redo"] = "ScreenAnnotation_Redo";
    MetricsEventName["ScreenAnnotation_Resize"] = "ScreenAnnotation_Resize";
    MetricsEventName["ScreenAnnotation_Clear"] = "ScreenAnnotation_Clear";
    MetricsEventName["ScreenAnnotation_Delta"] = "ScreenAnnotation_Delta";
    MetricsEventName["ScreenAnnotation_RemoteLoadAnnotations"] = "ScreenAnnotation_RemoteLoadAnnotations";
    MetricsEventName["ScreenAnnotation_Deactivate"] = "ScreenAnnotation_Deactivate";
    MetricsEventName["ScreenAnnotation_Activate"] = "ScreenAnnotation_Activate";
    MetricsEventName["ScreenAnnotation_ClearSelection"] = "ScreenAnnotation_ClearSelection";
    MetricsEventName["ScreenAnnotation_DeleteSelection"] = "ScreenAnnotation_DeleteSelection";
    MetricsEventName["ScreenAnnotation_SetZoom"] = "ScreenAnnotation_SetZoom";
    MetricsEventName["ScreenAnnotation_ScreenCapture"] = "ScreenAnnotation_ScreenCapture";
    MetricsEventName["ScreenAnnotation_EnableCursor"] = "ScreenAnnotation_EnableCursor";
    MetricsEventName["AUTODND_TOGGLE"] = "AutoDnD: Toggle";
    MetricsEventName["AUTODND_MODAL_SHOWN"] = "AutoDnD: Modal Shown";
    MetricsEventName["ONBOARDING_CHECKLIST_VIEWED"] = "Onboarding Checklist: Viewed";
    MetricsEventName["ONBOARDING_CHECKLIST_CLICKED"] = "Onboarding Checklist: Clicked";
    MetricsEventName["ONBOARDING_CHECKLIST_MORE_INFO_CLICKED"] = "Onboarding Checklist: More Info Clicked";
    MetricsEventName["ONBOARDING_CHECKLIST_COMPLETED"] = "Onboarding Checklist: Completed";
    MetricsEventName["ONBOARDING_CHECKLIST_SHOW_WINDOW_CLICKED"] = "Onboarding Checklist: Show Window Clicked";
    MetricsEventName["ONBOARDING_CHECKLIST_HIDE_WINDOW_CLICKED"] = "Onboarding Checklist: Hide Window Clicked";
    MetricsEventName["ONBOARDING_CHECKLIST_DISMISSED"] = "Onboarding Checklist: Dismissed";
    MetricsEventName["IN_APP_SURVEY_SHOWN"] = "In App Survey: Shown";
    MetricsEventName["IN_APP_SURVEY_DISMISSED"] = "In App Survey: Dismissed";
    MetricsEventName["IN_APP_SURVEY_RESPONSE"] = "In App Survey: Response";
    MetricsEventName["FEEDBACK_MODAL_OPENED"] = "Feedback Modal Opened";
})(MetricsEventName || (exports.MetricsEventName = MetricsEventName = {}));
var MetricsEventCategory;
(function (MetricsEventCategory) {
    MetricsEventCategory["ONBOARDING"] = "Onboarding";
    MetricsEventCategory["SPACE"] = "In-Space";
    MetricsEventCategory["AUTHENTICATION"] = "Authentication";
    MetricsEventCategory["CREATION"] = "Creation";
    MetricsEventCategory["REVENUE"] = "Revenue";
})(MetricsEventCategory || (exports.MetricsEventCategory = MetricsEventCategory = {}));
var MetricsUserProperties;
(function (MetricsUserProperties) {
    MetricsUserProperties["EMAIL"] = "email";
    MetricsUserProperties["IS_EMPLOYEE"] = "isGatherEmployee";
    MetricsUserProperties["REVENUE"] = "revenue";
    MetricsUserProperties["REVENUE_SUBSCRIPTION"] = "revenueSubscription";
    MetricsUserProperties["FIRST_PLATFORM"] = "firstPlatform";
    MetricsUserProperties["MOST_RECENT_PLATFORM"] = "mostRecentPlatform";
    MetricsUserProperties["FPS"] = "fps";
    MetricsUserProperties["HARDWARE_TIER"] = "hardwareTier";
    MetricsUserProperties["GPU_TIER"] = "gpuTier";
    MetricsUserProperties["GPU_POWER_LEVEL"] = "gpuPowerLevel";
    MetricsUserProperties["GPU_PERFORMANCE"] = "gpuPerformance";
    MetricsUserProperties["DEVICE_MEMORY"] = "deviceMemory";
    MetricsUserProperties["HARDWARE_CONCURRENCY"] = "hardwareConcurrency";
    MetricsUserProperties["MOST_RECENT_MAP_CATEGORY_ENTERED"] = "mostRecentMapCategoryEntered";
    MetricsUserProperties["FIRST_UNIQUE_MAP_CATEGORY_ENTERED"] = "firstUniqueMapCategoryEntered";
    MetricsUserProperties["SECOND_UNIQUE_MAP_CATEGORY_ENTERED"] = "secondUniqueMapCategoryEntered";
    MetricsUserProperties["THIRD_UNIQUE_MAP_CATEGORY_ENTERED"] = "thirdUniqueMapCategoryEntered";
    MetricsUserProperties["WELCOME_AND_JOIN_SPACE_EMAIL_NEW"] = "WelcomeAndJoinSpaceEmailNew";
    MetricsUserProperties["IS_SIGNED_IN"] = "isSignedIn";
    MetricsUserProperties["CONNECTED_PERSONAL_CAL"] = "personalCal";
    MetricsUserProperties["CONNECTED_PERSONAL_OUTLOOK_CAL"] = "personalOutlookCal";
    MetricsUserProperties["AUTO_MINIMODE"] = "autoMinimodeEnabled";
    MetricsUserProperties["NOISE_REDUCTION"] = "noiseReductionEnabled";
    MetricsUserProperties["ENHANCED_NOISE_REDUCTION"] = "enhancedNoiseReduction";
})(MetricsUserProperties || (exports.MetricsUserProperties = MetricsUserProperties = {}));
var MetricsGroupTypes;
(function (MetricsGroupTypes) {
    MetricsGroupTypes["ORG_ID"] = "orgId";
    MetricsGroupTypes["SPACE_ID"] = "spaceId";
})(MetricsGroupTypes || (exports.MetricsGroupTypes = MetricsGroupTypes = {}));
var MetricsGroupProperties;
(function (MetricsGroupProperties) {
    MetricsGroupProperties["USE_CASE"] = "useCase";
    MetricsGroupProperties["NUM_OBJECTS"] = "numObjects";
    MetricsGroupProperties["IS_PREMIUM"] = "isPremium";
})(MetricsGroupProperties || (exports.MetricsGroupProperties = MetricsGroupProperties = {}));
var AmplitudeIdentifyOperations;
(function (AmplitudeIdentifyOperations) {
    AmplitudeIdentifyOperations["SET"] = "set";
    AmplitudeIdentifyOperations["SET_ONCE"] = "setOnce";
    AmplitudeIdentifyOperations["ADD"] = "add";
    AmplitudeIdentifyOperations["APPEND"] = "append";
    AmplitudeIdentifyOperations["PREPEND"] = "prepend";
    AmplitudeIdentifyOperations["UNSET"] = "unset";
    AmplitudeIdentifyOperations["PRE_INSERT"] = "preInsert";
    AmplitudeIdentifyOperations["POST_INSERT"] = "postInsert";
    AmplitudeIdentifyOperations["REMOVE"] = "remove";
})(AmplitudeIdentifyOperations || (exports.AmplitudeIdentifyOperations = AmplitudeIdentifyOperations = {}));
var AmplitudeGroupIdentifyOperations;
(function (AmplitudeGroupIdentifyOperations) {
    AmplitudeGroupIdentifyOperations["SET"] = "set";
    AmplitudeGroupIdentifyOperations["SET_ONCE"] = "setOnce";
    AmplitudeGroupIdentifyOperations["ADD"] = "add";
    AmplitudeGroupIdentifyOperations["APPEND"] = "append";
    AmplitudeGroupIdentifyOperations["PREPEND"] = "prepend";
    AmplitudeGroupIdentifyOperations["UNSET"] = "unset";
})(AmplitudeGroupIdentifyOperations || (exports.AmplitudeGroupIdentifyOperations = AmplitudeGroupIdentifyOperations = {}));
exports.MAP_CATEGORY_ENTERED_PROPERTY = {
    1: MetricsUserProperties.FIRST_UNIQUE_MAP_CATEGORY_ENTERED,
    2: MetricsUserProperties.SECOND_UNIQUE_MAP_CATEGORY_ENTERED,
    3: MetricsUserProperties.THIRD_UNIQUE_MAP_CATEGORY_ENTERED,
};
var EventSource;
(function (EventSource) {
    EventSource["DeskWidget"] = "Desk Widget";
    EventSource["ProfileCard"] = "Profile Card";
    EventSource["QuickActionsMenu"] = "Quick Actions Menu";
    EventSource["DeskIsland"] = "Desk Island";
    EventSource["DoubleClickAvatar"] = "Double Click Avatar";
    EventSource["WaveNotification"] = "Wave Notification";
    EventSource["RingNotification"] = "Ring Notification";
    EventSource["MobileProfileCard"] = "Mobile Profile Card";
    EventSource["OldPlayerCard"] = "PlayerCard";
    EventSource["ParticipantsPanelRow"] = "ParticipantsPanelRow";
    EventSource["ParticipantsPanelGrid"] = "ParticipantsPanelGrid";
    EventSource["LocatePill"] = "LocatePill";
    EventSource["PlayerVideoControls"] = "PlayerVideoControls";
    EventSource["Toolbar"] = "Toolbar";
    EventSource["ToolbarAdditionalOptionsMenu"] = "ToolbarAdditionalOptionsMenu";
    EventSource["ToolbarParticipantsDropdownInviteMoreModal"] = "ToolbarParticipantsDropdownInviteMoreModal";
})(EventSource || (exports.EventSource = EventSource = {}));
var DeskClaimSource;
(function (DeskClaimSource) {
    DeskClaimSource["ClaimButtonOnMap"] = "Claim Desk Button on Map";
    DeskClaimSource["UserEduModal"] = "User Education Modal";
    DeskClaimSource["ClaimAnyDeskInvite"] = "Claim Any Desk Invite";
})(DeskClaimSource || (exports.DeskClaimSource = DeskClaimSource = {}));
var SignInMethods;
(function (SignInMethods) {
    SignInMethods["Apple"] = "Apple";
    SignInMethods["Google"] = "Google";
    SignInMethods["OTP"] = "OTP";
    SignInMethods["SSO"] = "SSO";
})(SignInMethods || (exports.SignInMethods = SignInMethods = {}));
var InviteModalVersion;
(function (InviteModalVersion) {
    InviteModalVersion["Legacy"] = "legacy";
    InviteModalVersion["New"] = "new";
    InviteModalVersion["Onboarding"] = "onboarding";
    InviteModalVersion["RWE_Hangout"] = "rwe_hangout";
})(InviteModalVersion || (exports.InviteModalVersion = InviteModalVersion = {}));
var FeedbackReason;
(function (FeedbackReason) {
    FeedbackReason["VideoOrAudio"] = "VideoOrAudio";
    FeedbackReason["Performance"] = "Performance";
    FeedbackReason["Connection"] = "Connection";
    FeedbackReason["MapDisplayIssues"] = "MapDisplayIssues";
    FeedbackReason["Others"] = "Others";
})(FeedbackReason || (exports.FeedbackReason = FeedbackReason = {}));
var HelpReason;
(function (HelpReason) {
    HelpReason["StartOffice"] = "StartOffice";
    HelpReason["RunMeetings"] = "RunMeetings";
    HelpReason["CustomizeSpace"] = "CustomizeSpace";
    HelpReason["BillSubscriptions"] = "BillSubscriptions";
    HelpReason["ProductFeedback"] = "ProductFeedback";
    HelpReason["Other"] = "Other";
    HelpReason["MeetingRecording"] = "MeetingRecording";
})(HelpReason || (exports.HelpReason = HelpReason = {}));
exports.HumanReadableFeedbackReason = {
    [FeedbackReason.VideoOrAudio]: "Video or audio issues",
    [FeedbackReason.Performance]: "Slowness or performance issues",
    [FeedbackReason.Connection]: "I’m being disconnected from my space",
    [FeedbackReason.MapDisplayIssues]: "Map display issues",
    [FeedbackReason.Others]: "Other bugs or issues",
};
exports.HumanReadableHelpReason = {
    [HelpReason.StartOffice]: "Onboarding help",
    [HelpReason.RunMeetings]: "Running meetings",
    [HelpReason.MeetingRecording]: "Meeting recording",
    [HelpReason.CustomizeSpace]: "Customizing your space",
    [HelpReason.BillSubscriptions]: "Billing & subscriptions",
    [HelpReason.ProductFeedback]: "Product feedback",
    [HelpReason.Other]: "Other reason",
};
var JoinType;
(function (JoinType) {
    JoinType["NewMember"] = "new member";
    JoinType["MemberRedirect"] = "member redirect";
    JoinType["GuestRedirect"] = "guest redirect";
})(JoinType || (exports.JoinType = JoinType = {}));
var BrowserContext;
(function (BrowserContext) {
    BrowserContext["MsOffice"] = "MsOffice";
})(BrowserContext || (exports.BrowserContext = BrowserContext = {}));
//# sourceMappingURL=constants.js.map